import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {AccountAdminDto} from '../../dtos/accountAdmin.dto';
import {environment} from '../../../environments/environment';
import {AccountAdminOverviewDto} from '../../dtos/accountAdminOverviewDto';

@Injectable({
    providedIn: 'root'
})
export class AccountAdminService {

    constructor(private httpClient: HttpClient) {
    }

    public allAccounts(): Observable<AccountAdminOverviewDto[]> {
        return this.httpClient.get<any>(environment.apiUrl + 'api/accounts/admin/v1/findAllOverview')
            .pipe(map(accountsData => {
                const accounts: AccountAdminOverviewDto[] = [];
                (accountsData as AccountAdminOverviewDto[]).forEach(datum => {
                    accounts.push(new AccountAdminOverviewDto().deserialize(datum));
                });
                return accounts;
            }));
    }

    public accountsByEmailLike(query: string): Observable<AccountAdminDto[]> {
        const encoded = encodeURIComponent(query || '');
        const url = environment.apiUrl + 'api/accounts/admin/v1/emailLike?query=' + encoded;
        return this.httpClient.get<any>(url).pipe(map(accountsData => {
            const accounts: AccountAdminDto[] = [];
            for (const datum of (accountsData as any)) {
                accounts.push(new AccountAdminDto().deserialize(datum));
            }
            return accounts;
        }));
    }

    public get(accountCode: string): Observable<AccountAdminDto> {
        return this.httpClient.get<any>(environment.apiUrl + 'api/accounts/admin/v1/' + accountCode)
            .pipe(map(accountData => {
                return new AccountAdminDto().deserialize(accountData);
            }));
    }

    public updateAccountMetas(accounDto: AccountAdminDto): Observable<AccountAdminDto> {
        return this.httpClient.put<any>(environment.apiUrl + 'api/accounts/admin/v1/updateMetas', accounDto)
            .pipe(map(accountData => {
                return new AccountAdminDto().deserialize(accountData);
            }));
    }

    /**
     * Removes a single meta field from an account. Requires the ADMIN role on the server.
     */
    public deleteAccountMeta(accountCode: string, metaCode: string): Observable<void> {
        const httpParams = new HttpParams().set('accountCode', accountCode);

        return this.httpClient.delete<any>(environment.apiUrl + 'api/accounts/admin/v1/deleteMeta/' + metaCode,
            {params: httpParams});
    }

    public async findAllPagingPersonalDetails(page: number): Promise<AccountAdminDto[]> {
        const httpParams = new HttpParams().set('page', page.toString());

        return await this.httpClient.get<AccountAdminDto[]>(environment.apiUrl + 'api/accounts/admin/v1/findAllPagingPersonalDetails',
                { params: httpParams })
                .toPromise();
    }
}
